import './images';
// import.meta.glob([
//     '../img/**',
// ]);

document.addEventListener('DOMContentLoaded', function () {
    let mainNavigation = document.getElementById('primary-navigation')
    let mainNavigationToggle = document.getElementById('primary-menu-toggle')

    if(mainNavigation && mainNavigationToggle) {
        mainNavigationToggle.addEventListener('click', function (e) {
            e.preventDefault()
            mainNavigation.classList.toggle('hidden')
        })
    }
        // ── Scroll Reveal ────────────────────────────────────────────
        const observer = new IntersectionObserver(entries => {
            entries.forEach(e => {
                if (e.isIntersecting) e.target.classList.add('visible');
            });
        }, { threshold: 0.1 });

        document.querySelectorAll('.reveal').forEach(el => observer.observe(el));


document.addEventListener('click', function (e) {
    const link = e.target.closest('.menu-item-has-children > a');

    if (!link) {
        // clicked outside any parent-link — close everything open
        document.querySelectorAll('.sub-menu:not(.hidden)').forEach(function (submenu) {
            submenu.classList.add('hidden');
            submenu.parentElement.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
        });
        return;
    }

    e.preventDefault();
    e.stopPropagation();

    const li = link.closest('.menu-item-has-children');
    const submenu = li.querySelector(':scope > .sub-menu');
    const isOpen = !submenu.classList.contains('hidden');

    // close sibling submenus at the same level
    const siblingSubmenus = li.parentElement.querySelectorAll(':scope > li > .sub-menu');
    siblingSubmenus.forEach(function (sm) {
        if (sm !== submenu) {
            sm.classList.add('hidden');
            sm.parentElement.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
        }
    });

    submenu.classList.toggle('hidden', isOpen);
    link.setAttribute('aria-expanded', String(!isOpen));
});

// close everything if clicking outside the nav entirely
document.addEventListener('click', function (e) {
    if (!e.target.closest('#primary-navigation')) {
        document.querySelectorAll('.sub-menu:not(.hidden)').forEach(function (submenu) {
            submenu.classList.add('hidden');
        });
        document.querySelectorAll('a[aria-expanded="true"]').forEach(function (link) {
            link.setAttribute('aria-expanded', 'false');
        });
    }
    });
});